// extracted by mini-css-extract-plugin
export default {"message":"MessageComponent_message__aO8o4","success":"MessageComponent_success__44pOE","error":"MessageComponent_error__w5MOX"};